var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApprovalManagementPending(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.80625 10.3C10.684 10.3 12.2063 8.77777 12.2063 6.9C12.2063 5.02223 10.684 3.5 8.80625 3.5C6.92848 3.5 5.40625 5.02223 5.40625 6.9C5.40625 8.77777 6.92848 10.3 8.80625 10.3Z",
    stroke: "#F97316",
    strokeWidth: 0.85
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6 16.6687C15.6 18.781 15.6 20.4937 8.8 20.4937C2 20.4937 2 18.781 2 16.6687C2 14.5565 5.0447 12.8438 8.8 12.8438C12.5553 12.8438 15.6 14.5565 15.6 16.6687Z",
    stroke: "#F97316",
    strokeWidth: 0.85
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 11.6241H14.512C14.512 11.7203 14.57 11.8071 14.6589 11.8439C14.7479 11.8808 14.8502 11.8604 14.9183 11.7924L14.75 11.6241ZM16.45 9.92406V9.68606H16.3514L16.2817 9.75577L16.45 9.92406ZM14.512 9.92406V11.6241H14.988V9.92406H14.512ZM14.9183 11.7924L16.6183 10.0924L16.2817 9.75577L14.5817 11.4558L14.9183 11.7924ZM16.45 10.1621H20.87V9.68606H16.45V10.1621ZM21.788 9.24406V5.84406H21.312V9.24406H21.788ZM20.87 4.92606H15.43V5.40206H20.87V4.92606ZM14.512 5.84406V9.92406H14.988V5.84406H14.512ZM15.43 4.92606C14.923 4.92606 14.512 5.33707 14.512 5.84406H14.988C14.988 5.59995 15.1859 5.40206 15.43 5.40206V4.92606ZM21.788 5.84406C21.788 5.33707 21.377 4.92606 20.87 4.92606V5.40206C21.1141 5.40206 21.312 5.59995 21.312 5.84406H21.788ZM20.87 10.1621C21.377 10.1621 21.788 9.75106 21.788 9.24406H21.312C21.312 9.48817 21.1141 9.68606 20.87 9.68606V10.1621Z",
    fill: "#F97316"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6035 6.97656L16.4531 8.12692M16.4531 6.97656L17.6035 8.12692M18.4663 7.55174L19.0414 8.12692L20.1918 6.97656",
    stroke: "#F97316",
    strokeWidth: 0.402626,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovalManagementPending);
export default __webpack_public_path__ + "static/media/approval_management_pending.39b2753ed1a1b20342a60778c3fcaa84.svg";
export { ForwardRef as ReactComponent };